var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatPlaceholder1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#3282B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0016 12.3158C24.3886 12.3158 22.8417 12.9566 21.7011 14.0971C20.5605 15.2377 19.9197 16.7847 19.9197 18.3977C19.9197 20.0107 20.5605 21.5576 21.7011 22.6982C22.8417 23.8388 24.3886 24.4796 26.0016 24.4796C27.6147 24.4796 29.1616 23.8388 30.3022 22.6982C31.4428 21.5576 32.0835 20.0107 32.0835 18.3977C32.0835 16.7847 31.4428 15.2377 30.3022 14.0971C29.1616 12.9566 27.6147 12.3158 26.0016 12.3158ZM21.8559 30.4253C21.3877 29.9833 20.7474 29.7227 20.1247 29.8865C16.1719 30.9257 12.3174 32.9237 12.3174 35.8831V38.0421C12.3174 38.949 13.0526 39.6842 13.9595 39.6842H38.0438C38.9507 39.6842 39.6859 38.949 39.6859 38.0421V35.8831C39.6859 32.9237 35.8314 30.9257 31.8786 29.8865C31.2559 29.7227 30.6156 29.9833 30.1474 30.4253C29.0633 31.4487 27.6104 32.0819 26.0016 32.0819C24.3929 32.0819 22.9399 31.4487 21.8559 30.4253Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPlaceholder1);
export default __webpack_public_path__ + "static/media/ChatPlaceholder1.26c8b16ebb0cb0e0b4b82a931053071d.svg";
export { ForwardRef as ReactComponent };